import { useNavigate, useParams } from 'react-router'
import { toast } from 'sonner'
import useSWR from 'swr'

import { PageHeader } from '@/components/ds'
import { Skeleton } from '@/components/ui/skeleton'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { StandaloneParticipantForm } from '@/forms/ParticipantForm/StandaloneParticipantForm'
import { Participant } from '@/interfaces/Participant'

export default function ContactEditPage() {
  const { id } = useParams()
  const navigate = useNavigate()

  const { data: contact, isLoading, mutate } = useSWR<Participant>(`/api/v2/contacts/${id}`, apiFetcher)

  const title = contact?.name || 'Kontakt'

  useSetPageHeader({
    breadcrumbs: [
      { href: '/contacts', children: 'Kontakty' },
      { href: `/contact/${id}`, children: title },
      { href: `/contact/${id}/edit`, children: 'Upravit' },
    ],
    newButton: 'participant',
  })

  return (
    <>
      <title>{`Upravit: ${title}`}</title>
      <div className="mx-auto w-full max-w-[1280px]">
        <PageHeader title="Upravit kontakt" description={contact?.name} />

        {isLoading && (
          <div className="max-w-2xl space-y-4">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-full" />
            <div className="grid grid-cols-2 gap-4">
              <Skeleton className="h-8 w-full" />
              <Skeleton className="h-8 w-full" />
            </div>
          </div>
        )}

        {contact && (
          <StandaloneParticipantForm
            id={contact.id}
            type="customer"
            showAccountNumber
            showDefaultBankAccount
            submitLabel="Uložit kontakt"
            onCancel={() => navigate(`/contact/${contact.id}`)}
            defaultValues={{
              customer: {
                ...contact,
                businessId: contact.ico,
                taxId: contact.dic,
              },
            }}
            onSuccess={async (data) => {
              toast.success('Kontakt byl uložen.')
              await mutate(data, { revalidate: true })
              navigate(`/contact/${contact.id}`)
            }}
          />
        )}
      </div>
    </>
  )
}
